import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";

import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserDetails } from "../../../../utils/helpers";
import UseServerTable from "../../../../Hooks/UseServerTable";
import Page from "../../../../Components/Page";
import AlertComponent from "../../../../Components/AlertComponent";
import PageLoader from "../../../../Components/PageLoader";
import TransactionTable from "../../../../Components/TransactionTable";

const GuarantorshipWallet = ({ _user, showHeader = true }) => {
  const location = useLocation();
  const loggedInUser = getUserDetails();

  const [user, setUser] = useState(
    _user || location?.state?.user || loggedInUser,
  );
  const [data, setData] = useState([]);
  const [status, setStatus] = useState("active");

  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const navigate = useNavigate();
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // const [loading, response, request] = FetchHook();

  // const fetchData = useCallback(async () => {
  //   await request({
  //     url: `/wallet_transaction?type=saving_wallet`,
  //   });
  // }, [user]);

  // useEffect(() => {
  //   fetchData();
  // }, [fetchData]);

  // useEffect(() => {
  //   if (response && response.status === 200 && response.data.StatusCode === 0) {
  //     setData(response.data.Loan);
  //   }
  // }, [response]);/wallet_transaction?type=saving_wallet

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl: `/wallet_transaction?type=guarantorship_wallet&entity_id='${user.id}'`,
    onSuccess: (data) => {
      setData(data.Loan);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  const columns = [
    {
      field: "transaction_id",
      headerName: "Transaction id",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "source_transaction_id",
      headerName: "Source transaction id",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "account_number",
      headerName: "Account number",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "loan_id",
      headerName: "Loan id",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "global_request_id",
      headerName: "Global request id",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "dr_cr_pair_id",
      headerName: "Dr Cr pair",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "debit",
      headerName: "Debit (money out)",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "credit",
      headerName: "Credit (money in)",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "balance_before",
      headerName: "Balance before",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "balance_after",
      headerName: "Balance after",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "description",
      headerName: "Description",
      minWidth: 300,
      flex: 1,
    },
    {
      field: "transaction_status",
      headerName: "Status",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "transaction_settlement_time",
      headerName: "Transaction settlement time",
      minWidth: 170,
      flex: 1,
      valueFormatter: (params) =>
        moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    },
    {
      field: "transaction_timestamp",
      headerName: "Transaction time",
      minWidth: 170,
      flex: 1,
      valueFormatter: (params) =>
        moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    },
    // {
    //   field: "actions",
    //   headerName: "Actions",
    //   renderCell: (row) => (
    //     <Button
    //       variant="contained"
    //       style={{ marginLeft: 16, fontWeight: "bold" }}
    //       disabled={row.row.status === 1 ? false : true}
    //       onClick={() => fixLoanRequest(row.row)}
    //     >
    //       {fixLoading ? "Fixing..." : "Fix request"}
    //     </Button>
    //   ),
    //   width: 200,
    // },
  ];

  const custCols = [
    // {
    //   field: "transaction_id",
    //   headerName: "Transaction id",
    //   width: 170,
    // },
    // {
    //   field: "debit",
    //   headerName: "Debit (money out)",
    // },
    // {
    //   field: "credit",
    //   headerName: "Credit (money in)",
    // },
    // {
    //   field: "balance_before",
    //   headerName: "Balance before",
    // },
    // {
    //   field: "balance_after",
    //   headerName: "Balance after",
    // },
    // {
    //   field: "description",
    //   headerName: "Description",
    //   width: 350,
    // },
    // {
    //   field: "transaction_status",
    //   headerName: "Status",
    // },
    // {
    //   field: "transaction_timestamp",
    //   headerName: "Transaction time",
    //   width: 200,
    //   valueFormatter: (params) =>
    //     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    // },
    {
      field: "actions",
      headerName: "Actions",
      renderCell: (row) => (
        <Button
          variant="outlined"
          style={{ marginLeft: 16, fontWeight: "bold" }}
          onClick={() =>
            navigate("/dashboard/user/guarantorship-wallet-statements", {
              state: { user, guarantorshipWallet: row.row },
            })
          }
        >
          View more
        </Button>
      ),
      width: 200,
    },
  ];

  return (
    <Page title={"Guarantorship Wallet Transactions"} showHeader={showHeader}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Card>
        <CardHeader
          title={
            <>
              {showHeader === false && (
                <Typography variant="h6">
                  Guarantorship Wallet Transactions
                </Typography>
              )}
            </>
          }
        />
        <CardContent>
          {gridProps.loading ? (
            <PageLoader />
          ) : data && data.length > 0 ? (
            <TransactionTable
              data={data}
              // columns={loggedInUser.role === "admin" ? columns : custCols}
              // columns={custCols}
              extraColumns={custCols}
              {...gridProps}
            />
          ) : (
            <Grid display={"flex"} justifyContent={"center"}>
              <Typography align="center">You have no transactions!</Typography>
            </Grid>
          )}
        </CardContent>
      </Card>
    </Page>
  );
};

export default GuarantorshipWallet;
